import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-1",
  role: "region",
  "aria-labelledby": "home-categories-title"
}
const _hoisted_2 = { id: "home-categories-title" }
const _hoisted_3 = {
  id: "home-global-tags-title",
  class: "_z-2"
}
const _hoisted_4 = { class: "_flexcol _gap-1" }
const _hoisted_5 = {
  key: 1,
  class: "_flexcol _gap-6"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_launch_project_box = _resolveComponent("launch-project-box")
  const _component_info_tile_list = _resolveComponent("info-tile-list")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_grouped_box_list = _resolveComponent("grouped-box-list")
  const _component_box_list = _resolveComponent("box-list")
  const _component_scrollable_wrapper = _resolveComponent("scrollable-wrapper")
  const _component_skeleton_tile = _resolveComponent("skeleton-tile")
  const _component_skeleton_box_list = _resolveComponent("skeleton-box-list")
  const _component_section_expander = _resolveComponent("section-expander")

  return (_openBlock(), _createBlock(_component_section_expander, { class: "_h-full" }, {
    default: _withCtx(() => [
      (_ctx.isInitialized)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass($options.wrapperClassList)
          }, [
            ($options.isLaunchCampaignBoxEnabled)
              ? (_openBlock(), _createBlock(_component_launch_project_box, { key: 0 }))
              : _createCommentVNode("v-if", true),
            (!$options.isLaunchCampaignBoxEnabled)
              ? (_openBlock(), _createBlock(_component_info_tile_list, {
                  key: 1,
                  items: $options.projectTypeTags
                }, null, 8 /* PROPS */, ["items"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("section", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_icon, {
                  name: "shape",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectPropertiesCategoryLabel), 1 /* TEXT */)
              ]),
              ($options.hasCategoriesSubItems)
                ? (_openBlock(), _createBlock(_component_grouped_box_list, {
                    key: 0,
                    items: $options.categoryItems,
                    "data-qa": "ProjectCategoryTree"
                  }, null, 8 /* PROPS */, ["items"]))
                : (_openBlock(), _createBlock(_component_info_tile_list, {
                    key: 1,
                    items: $options.categoryItems
                  }, null, 8 /* PROPS */, ["items"]))
            ]),
            _createElementVNode("section", {
              class: _normalizeClass($options.globalTagsClassList),
              role: "region",
              "aria-labelledby": "home-global-tags-title"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_icon, {
                  name: "hashtag",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Homepage.ProjectListGlobalTagsTitle), 1 /* TEXT */)
              ]),
              _createVNode(_component_scrollable_wrapper, {
                "scroll-direction": _ctx.scrollDirections.vertical
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_box_list, { items: $options.projectGlobalTags }, null, 8 /* PROPS */, ["items"])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["scroll-direction"])
            ], 2 /* CLASS */)
          ], 2 /* CLASS */))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_skeleton_tile, { "items-count": 4 }),
            _createVNode(_component_skeleton_tile, { "items-count": 2 }),
            _createVNode(_component_skeleton_box_list, { "items-count": 20 })
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}